import { render, staticRenderFns } from "./SearchMessagesTab.vue?vue&type=template&id=055fd6cf&scoped=true"
import script from "./SearchMessagesTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchMessagesTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchMessagesTab.vue?vue&type=style&index=0&id=055fd6cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055fd6cf",
  null
  
)

export default component.exports